import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "@/auth/AuthProvider";
import { USER_ROLES } from "@/auth/userRoles";
import type { ComponentProps } from "react";
import { Link } from "react-router";
import { ROUTES } from "./navigation";

const LABEL = "Open raw files";

export const OpenRawFilesButton = ({
  encounterId,
  variant = "outline",
  newTab = false,
}: {
  encounterId: string | null | undefined;
  variant?: ComponentProps<typeof Button>["variant"];
  newTab?: boolean;
}) => {
  const { role } = useAuth();
  const canOpenRawFiles = role === USER_ROLES.admin || role === USER_ROLES.clinical_coder_admin;

  if (!canOpenRawFiles || !encounterId) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant={variant} size="sm" asChild>
            <Link
              to={`${ROUTES.rawFilesViewer.route}/${encounterId}`}
              aria-label={LABEL}
              {...(newTab && { target: "_blank", rel: "noopener noreferrer" })}
            >
              🗂️
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{LABEL}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
